type Violation = { message?: string }

type ExtractViolationMessageType = (response: Response) => Promise<string | undefined>

export const extractViolationMessage: ExtractViolationMessageType = async (response) => {
  try {
    const body = await response.json()
    const violations = body?.violations
    if (Array.isArray(violations)) {
      return violations
        .map((violation: Violation) => violation?.message)
        .filter(Boolean)
        .join('; ')
    }
    if (violations?.message) return violations.message
    return undefined
  } catch {
    return undefined
  }
}
